import {
    Component,
    ElementRef,
    HostListener,
    Input,
    OnInit,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Aero1200AuthenticationTokenRequest } from 'src/app/models/1200aero/Aero1200AuthenticationTokenResponse';
import { AircraftData, Aircraftwatch, FavoriteAicraftData, FlightWatchModelResponse } from 'src/app/models/flight-watch';
import { Aero1200Service } from 'src/app/services/1200aero/aero1200.service';
import { environment } from 'src/environments/environment';
import { Dictionary } from 'lodash';
import { FlightWatchMapService } from '../flight-watch-map-services/flight-watch-map.service';
import { AircraftDataDialogComponent } from './aircraft-data-dialog/aircraft-data-dialog.component';
import { Subscription } from 'rxjs';
import { FlightWatchMapSharedService } from '../../services/flight-watch-map-shared.service';
import { FlightWatchHelper } from '../../FlightWatchHelper.service';
import { EnumHelper } from 'src/app/helpers/enums/enum.helper.service';
import { AicraftFavorite } from 'src/app/core/favorites/favoriteAircraft.service';
import { FlightWatchService } from 'src/app/services/flightwatch.service';

export enum mapEventEnum {
    aicraftClick = 'AIRCRAFT_CLICK',
    aicraftClickUpdate = 'AIRCRAFT_CLICK_UPDATE',
    mapDrawerAicraftClick = 'MAP_DRAWER_AIRCRAFT_CLICK',
    selectedflight= 'SELECTED_FLIGHT'
}

@Component({
    selector: 'app-twelve-hundred-aero-map',
    templateUrl: './twelve-hundred-aero-map.component.html',
    styleUrls: ['./twelve-hundred-aero-map.component.scss'],
})
export class TwelveHundredAeroMapComponent implements OnInit {
    @Input() fboId: number = null;
    @Input() icao: string = null;
    @Input() groupId: string = null;
    @Input() flightWatchData: FlightWatchModelResponse[] = [];

    public flightWatchDictionary: Dictionary<FlightWatchModelResponse>;

    @ViewChild('mapIframe') mapIframe!: ElementRef<HTMLIFrameElement>;

    authTokens: Aero1200AuthenticationTokenRequest = {
        token: null,
        authTokenFboLinx: null,
    };
    iframeUrl: string = '';
    safeUrl: SafeResourceUrl;
    areTokensSet = false;

    selectedAircraft: any = null;

    aicraftDetailsSubscription: Subscription;
    aicraftCompanyAssignSubscription: Subscription;

    constructor(
        private aeroService: Aero1200Service,
        private sanitizer: DomSanitizer,
        public dialog: MatDialog,
        private flightWatchMapService: FlightWatchMapService,
        private flightWatchHelper: FlightWatchHelper,
        private flightWatchMapSharedService: FlightWatchMapSharedService
    ) {
        this.iframeUrl = environment.flightWatch._1200aeroUrl;
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            this.iframeUrl
        );
        this.aicraftDetailsSubscription = this.flightWatchMapSharedService.aicraftDetails$.subscribe( (data: FlightWatchModelResponse) => {
                this.openDialog(data);
                this.selectAircraftEvent(data);
            });
        this.aicraftCompanyAssignSubscription = flightWatchMapSharedService.aicraftCompanyAssign$.subscribe( (data: Aircraftwatch) => {
            this.UpdateAicraftEvent(data);
        });
    }

    @HostListener('window:message', ['$event'])
    onMessage(event: MessageEvent) {        
        if(!EnumHelper.isEnumValue(mapEventEnum, event.data.type) && event.origin != environment.flightWatch._1200aeroUrl) return;

        if(event.data.type === mapEventEnum.selectedflight) {
            this.toogleFavoriteAircraft(event.data.data);
            return;
        }
        this.selectedAircraft = event.data.aircraft;
        this.flightWatchMapSharedService.getAndUpdateAircraftWithHistorical(this.fboId, this.icao, this.selectedAircraft.regn);
    }
    async toogleFavoriteAircraft(flightData: any): Promise<void> {
        this.flightWatchMapSharedService.getAndUpdateAircraftWithHistorical(this.fboId, this.icao, flightData.regn);
    }

    ngOnInit(): void {                  
    }
    ngOnDestroy() {
        this.aicraftDetailsSubscription.unsubscribe();
        this.aicraftCompanyAssignSubscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.fboId) {
            this.aeroService
                .getAuthenticationToken(this.fboId)
                .subscribe((response) => {
                    this.authTokens.authTokenFboLinx = response.authTokenFboLinx;
                    this.authTokens.token = response.authToken1200aero;
                    this.onIframeLoad();
                });
        }
        if (changes.icao) {
            this.iframeUrl = `${this.iframeUrl}?airport=${this.icao}`;
            this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                this.iframeUrl
            );
        }
        if(changes.flightWatchData){
            this.flightWatchDictionary = this.flightWatchMapService.getDictionaryByTailNumberAsKey(this.flightWatchData);
        }
    }

    ngAfterViewInit() {
        this.mapIframe.nativeElement.onload = () => {
            this.onIframeLoad();
          };
    }

    onIframeLoad(): void {
        const iframe = this.mapIframe.nativeElement;
        if(this.authTokens.token === null) return;
        // Use postMessage if necessary
        iframe.contentWindow?.postMessage(
            this.authTokens,
            '*'
        );
    }

    UpdateAicraftEvent(data: FavoriteAicraftData | any): void {
        if(this.selectedAircraft == null) return;
        this.selectedAircraft.isAircraftFavorited = data.favoriteAircraft != null;
        this.selectedAircraft.isFuelerLinxCustomer = data.customerInfoByGroupId > 0;

        this.sendPostMessageToIframe(this.selectedAircraft, mapEventEnum.aicraftClickUpdate);
    }
    selectAircraftEvent(data: FlightWatchModelResponse): void {
        const aircraftData: AircraftData = {
            isAircraftFavorited: data.favoriteAircraft != null,
            isFuelerLinxCustomer: data.customerInfoByGroupId > 0,
            isAircraftAddedByFbo: data.isInNetwork,
            hasUpcomingFuelRequest: data.isActiveFuelRelease,
            icao: data.aircraftHexCode,
            tailNumber: data.tailNumber,
            callsign: data.atcFlightNumber,
            latitude: data.latitude,
            longitude: data.longitude,
            departureICAO: data.departureICAO,
            arrivalICAO: data.arrivalICAO,
            liveBearing: data.liveBearing
        };
        console.log("🚀 ~ MAP_DRAWER_AIRCRAFT_CLICK data: ", aircraftData)

        this.sendPostMessageToIframe(aircraftData, mapEventEnum.mapDrawerAicraftClick);
    }

    openDialog(flightdata: FlightWatchModelResponse):  void { 
        const popupData = this.flightWatchHelper.mapFlightWatchModelResponseToAircraftwatch(flightdata);      
        const dialogRef = this.dialog.open(AircraftDataDialogComponent, {
          width: '410px',
          data: {fboId: this.fboId, flightData: popupData, groupId: this.groupId}    
        });
        dialogRef.afterClosed().subscribe(result => {
          if(!result) return;
            this.UpdateAicraftEvent(result);
            this.flightWatchMapSharedService.updateCustomerAicraftData(result);
        });
        
    }
    private sendPostMessageToIframe(data: any, type: string): void {   
        const iframe = this.mapIframe.nativeElement;

        iframe.contentWindow?.postMessage(
            { data, type },
            '*'
        );
    }
}
